<template>
  <div class="h5-page">
    <div class="h5-header">我的伙伴</div>
    <div class="h5-body">
      <a-list :loading="loading" :data-source="partners" :locale="{ emptyText: '暂无已绑定的伙伴' }">
        <a-list-item slot="renderItem" slot-scope="item">
          <a-list-item-meta :description="'绑定时间：' + (item.createTime || '-')">
            <span slot="title">
              {{ item.partnerName || '伙伴' + item.partnerTenantId }}
              <a-tag v-if="item.archiveType === '供应商'" color="green" style="margin-left: 8px">供应商</a-tag>
              <a-tag v-else-if="item.archiveType === '客户'" color="blue" style="margin-left: 8px">客户</a-tag>
            </span>
            <a-avatar slot="avatar" style="background-color: #1890ff" icon="shop" />
          </a-list-item-meta>
        </a-list-item>
      </a-list>
    </div>
    <h5-tab-bar active="partners" />
  </div>
</template>
<script>
import Vue from 'vue'
import { ACCESS_TOKEN } from '@/store/mutation-types'
import { getH5Partners } from '@/api/plugin/orderReceive'
import H5TabBar from './H5TabBar'
import './h5-common.css'

export default {
  name: 'H5Partners',
  components: { H5TabBar },
  data() {
    return {
      loading: false,
      partners: []
    }
  },
  created() {
    if (!this.checkLogin()) {
      return
    }
    this.loading = true
    getH5Partners().then(res => {
      if (res.success) {
        this.partners = res.data || []
      } else if (res.code === 401) {
        this.toLogin()
      } else {
        this.$message.warning(res.message)
      }
    }).finally(() => {
      this.loading = false
    })
  },
  methods: {
    checkLogin() {
      if (!Vue.ls.get(ACCESS_TOKEN)) {
        this.toLogin()
        return false
      }
      return true
    },
    toLogin() {
      this.$router.replace('/h5/login')
    }
  }
}
</script>
